import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SnUser } from '@lib/api/entities';

@Component({
  selector: 'sn-user-details',
  templateUrl: './user-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDetailsComponent {
  @Input()
  public user: SnUser;
}
